export enum SignInUserRole {
  Staff = "staff",
  Client = "client",
}

export const isValidRole = (role: SignInUserRole | undefined): boolean => {
  return role === SignInUserRole.Staff || role === SignInUserRole.Client;
};
